module.exports = __webpack_public_path__ + "img/b.534bc9a9.jpg";